import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {observer, inject} from 'mobx-react'
import {Checkbox} from 'react-bootstrap'
import '../containers/css/PresentIdeaOptions.css'

//Perhaps have a state and local true/false, because the state might be the new one already

class SlideListItem extends Component{
    static propTypes = {
        item: PropTypes.object.isRequired,
    }

    constructor(props) {
        super(props)
        this.enableSlide = this.enableSlide.bind(this)
        this.changeCheck = this.changeCheck.bind(this)
        this.state = {
            check: undefined,
        }
    }

    changeCheck(e, currentSlide){
        //This causes a re-render, but we are not using this state!
        this.setState({check: this.props.item.show})
    }

    enableSlide(e, currentSlide, key){
        const {stores} = this.props
        const {store} = stores
        const {theIdea} = store
        if (theIdea.slides[currentSlide]['show'] === true){
            this.props.stores.store.updateIdeaProp(
                key, 
                'slides/' + currentSlide + '/show', 
                false,
            )
        }
        else if (theIdea.slides[currentSlide]['show'] === false){
            this.props.stores.store.updateIdeaProp(
                key, 
                'slides/' + currentSlide + '/show', 
                true,
            )
        }
    }

    render() {
        return(
             <div className='presentationSlides'>
                <div className='slideCheckWrapper'>
                    <Checkbox
                        key={this.props.item.name} 
                        onClick={(e) => this.enableSlide(e, this.props.item.number, this.props.item.key)}
                        checked={this.props.item.show}
                        onChange={(e) => this.changeCheck(e, this.props.item.number)}
                        style={{margin: 6, verticalAlign: 'middle'}} 
                        inline>
                    </Checkbox>
                </div>
                <div className='slideTextWrapper'>
                    {this.props.item.text}
                </div>
            </div>
        )
    }
}

export default inject("stores")(observer(SlideListItem))



// WEBPACK FOOTER //
// ./src/containers/SlideListItem.js